// utils/getTotemsImages.ts
import nzouNdlovu, {
  ReactComponent as NzouNdlovu,
} from "../assets/totems/nzou-ndlovu.svg";
import shumbaSibanda, {
  ReactComponent as ShumbaSibanda,
} from "../assets/totems/shumba-sibanda.svg";
import gwayiTshuma, {
  ReactComponent as GwayiTshuma,
} from "../assets/totems/gwayi-tshuma.svg";
import hwesaMbeva, {
  ReactComponent as HwesaMbeva,
} from "../assets/totems/hwesa-mbeva.svg";
import makombeHumba, {
  ReactComponent as MakombeHumba,
} from "../assets/totems/makombe-humba.svg";
import maphosaNungu, {
  ReactComponent as MaphosaNungu,
} from "../assets/totems/maphosa-nungu.svg";
import mlamboSvosve, {
  ReactComponent as MlamboSvosve,
} from "../assets/totems/mlambo-svosve.svg";
import moyoMwoyo, {
  ReactComponent as MoyoMwoyo,
} from "../assets/totems/moyo-mwoyo.svg";
import mpofuMhofu, {
  ReactComponent as MpofuMhofu,
} from "../assets/totems/mpofu-mhofu.svg";
import ncubeSoko, {
  ReactComponent as NcubeSoko,
} from "../assets/totems/ncube-soko.svg";
import ngwenaNgwenya, {
  ReactComponent as NgwenaNgwenya,
} from "../assets/totems/ngwena-ngwenya.svg";
import nkomoGumbo, {
  ReactComponent as NkomoGumbo,
} from "../assets/totems/nkomo-gumbo.svg";

import nyoniHungwe, {
  ReactComponent as NyoniHungwe,
} from "../assets/totems/nyoni-hungwe.svg";
import temboDube, {
  ReactComponent as TemboDube,
} from "../assets/totems/tembo-dube.svg";

import { FunctionComponent, SVGProps } from "react";

export interface TotemDetails {
  name: string;
  Img: FunctionComponent<SVGProps<SVGSVGElement>>;
}

export interface TotemSvgDetails {
  name: string;
  img: string;
}

export const getTotemsImagesAsReactComponent = (): TotemDetails[] => [
  { name: "Nzou/Ndlovu", Img: NzouNdlovu },
  { name: "Shumba/Sibanda", Img: ShumbaSibanda },
  { name: "Gwayi/Tshuma", Img: GwayiTshuma },
  { name: "Hwesa/Mbeva", Img: HwesaMbeva },
  { name: "Maphosa/Nungu", Img: MaphosaNungu },
  { name: "Makombe/Humba", Img: MakombeHumba },
  { name: "Mlambo/Svosve", Img: MlamboSvosve },
  { name: "Moyo/Mwoyo", Img: MoyoMwoyo },
  { name: "Mpofu/Mhofu", Img: MpofuMhofu },
  { name: "Ncube/Soko", Img: NcubeSoko },
  { name: "Ngwena/Ngwenya", Img: NgwenaNgwenya },
  { name: "Nkomo/Gumbo", Img: NkomoGumbo },
  { name: "Nyoni/Hungwe", Img: NyoniHungwe },
  
  { name: "Tembo/Dube", Img: TemboDube },
];

export const getTotemsImagesAsImgSrc = (): TotemSvgDetails[] => [
  { name: "Nzou/Ndlovu", img: nzouNdlovu },
  { name: "Shumba/Sibanda", img: shumbaSibanda },
  { name: "Gwayi/Tshuma", img: gwayiTshuma },
  { name: "Hwesa/Mbeva", img: hwesaMbeva },
  { name: "Maphosa/Nungu", img: maphosaNungu },
  { name: "Makombe/Humba", img: makombeHumba },
  { name: "Mlambo/Svosve", img: mlamboSvosve },
  { name: "Moyo/Mwoyo", img: moyoMwoyo },
  { name: "Mpofu/Mhofu", img: mpofuMhofu },
  { name: "Ncube/Soko", img: ncubeSoko },
  { name: "Ngwena/Ngwenya", img: ngwenaNgwenya },
  { name: "Nkomo/Gumbo", img: nkomoGumbo },
  { name: "Nyoni/Hungwe", img: nyoniHungwe },
  
  { name: "Tembo/Dube", img: temboDube },
];
